export default {
  remote: 'metadata_search_tool_simplify',
  name: 'metadata-search-tool',
  source: 'https://github.com/telus/metadata-search-tool-simplify',
  urlMapping: {
    'localhost': 'http://localhost:4321/mf-manifest.json',
    'simplify.developers.telus.digital':
      'https://assets.wcpreview.telus.com/1217174567/metadata-search-tool-simplify/v1/mf2/mf-manifest.json',
    'simplify.staging.developers.telus.digital':
      'https://assets.wcstage.telus.com/1217174567/metadata-search-tool-simplify/v1/mf2/mf-manifest.json',
    'simplify.telus.com':
      'https://assets.telus.com/1217174567/metadata-search-tool-simplify/v1/mf2/mf-manifest.json',
  }
};

